import _bundle from '../../core/core--bundles';
import {companyData} from '../global/change-company';

const $pcoGrid = $('#pcoMainGrid');

export default function () {
    if ($pcoGrid.length) initGrid();

    _bundle.add({
        name: 'Reload PCO',
        event: ['on:CompanyChange'],
        fn() {
            companyData.reloadQueryString = `?company=${companyData.id}`;
        }
    });
    
}

const legalTag = $('<span class="tag tag--small tag--purple">Legal Review</span>');
const pcoStatusSelection = ['Fully Approved', 'Unapproved', 'Both'];

const goToPcoDetailPage = (e) => {
    const $row = $(e.currentTarget);
    const contract = $row.find('[data-contract]').data('contract');

    window.location.href = `${window.location.origin}/Operations/PcoApproval/PcoDetail?contract=${contract}`;
};

const pcoGridDataBound = (arg) => {
    const $grid = arg.sender;
    const $element = $grid.element;
    const $rows = $element.find('tbody [role="row"]');
    $rows.click(goToPcoDetailPage);

    const dv = $grid.dataSource.view();
    dv.forEach(function (ele) {
        const rowSelector = `tr[data-uid="${ele.uid}"]`;
        const row = $element.find(rowSelector);
        const cellA = row.find('td[data-field="PcoATotal"]');
        const cellB = row.find('td[data-field="PcoBTotal"]');
        const cellC = row.find('td[data-field="PcoCTotal"]');
        const contractCell = row.find('td[data-field="Contract"]');

        if(ele.PcoAFullyApproved === false && !(ele.PcoATotal === 0)) {
            cellA.addClass('bg-danger-light');
        }
        if(ele.PcoBFullyApproved === false && !(ele.PcoBTotal === 0)) {
            cellB.addClass('bg-danger-light');
        }
        if(ele.PcoCFullyApproved === false && !(ele.PcoCTotal === 0)) {
            cellC.addClass('bg-danger-light');
        }
        if(ele.LegalReviewRequired === true) {
            contractCell.append(legalTag.clone());
        }
    });
    
    $('#grid-loading').hide();
}

const highlightColMenus = () => {
    const grid = $pcoGrid.data('kendoGrid');
    const table = grid.element;
    const gds = grid.dataSource;
    const currentFilter = gds.filter();
    const filteredPcos = [];

    if(currentFilter.filters.find(f => {
        if (/Pco[ABC]FullyApproved/.test(f.field)) {
            const pcoLetter = f.field.charAt(3);
            filteredPcos.push(pcoLetter);
            return true;
        }
        return false;
    })) {
        // Add classes for active column menus.
        filteredPcos.forEach(f =>
            table.find(`th[data-field="Pco${f}Total"]`)
                .find('a.k-header-column-menu')
                .addClass('k-state-active')
        );
    }
}

const addPcoApprovalFilter = (filterForm, pcoType) => {
    let pcoLetter;
    switch (pcoType) {
        case 'PcoATotal':
            pcoLetter = 'A';
            break;
        case 'PcoBTotal':
            pcoLetter = 'B';
            break;
        case 'PcoCTotal':
            pcoLetter = 'C';
            break;
        default:
            return;
    }
    const filterMenu = filterForm.find('div.k-filter-menu-container');
    const filterActions = filterMenu.find('div.k-action-buttons');
    const clear = filterActions.find('button[type="reset"]');
    const approvalDiv = $('<div/>');
    const text = $(`<div class="k-filter-help-text">Show projects with PCO-${pcoLetter}s that are:</div>`);
    const dropDownDiv = $(`<div id="pcoApprovalFilter${pcoLetter}"/>`);

    approvalDiv.append(text, dropDownDiv);
    approvalDiv.insertBefore(filterActions);

    dropDownDiv.kendoDropDownList({
        autoBind: true,
        dataSource: pcoStatusSelection,
        value: 'Both'
    });

    const filterField = `Pco${pcoLetter}FullyApproved`;
    filterForm.on('submit', function(bc){
        const ddl = $(`#pcoApprovalFilter${pcoLetter}`).data('kendoDropDownList');
        const ddlVal = ddl.value();
        const grid = $pcoGrid.data('kendoGrid');
        const gds = grid.dataSource;
        const currentFilter = gds.filter();
        
        if(ddlVal === 'Both') {
            if(!currentFilter) {
                highlightColMenus();
                return false;
            }
            const filterIndex = currentFilter.filters.findIndex(f => f.field === filterField);
            if(filterIndex >= 0) currentFilter.filters.splice(filterIndex, 1);
            gds.filter(currentFilter);
            highlightColMenus();
            return false;
        }
        
        const filterValue = ddlVal === 'Fully Approved';
        const filterToAdd = { field: filterField, operator: 'eq', value: filterValue };
        if(currentFilter) {
            const filterIndex = currentFilter.filters.findIndex(f => f.field === filterField);
            if(filterIndex >= 0) currentFilter.filters.splice(filterIndex, 1, filterToAdd);
            else currentFilter.filters.push(filterToAdd);
            gds.filter(currentFilter);
        }
        else{
            gds.filter(filterToAdd);
        }
        highlightColMenus();
        return false;
    });
    clear.on('click', function(bc){
        const grid = $pcoGrid.data('kendoGrid');
        const gds = grid.dataSource;
        const currentFilter = gds.filter();
        if(currentFilter) {
            const filterIndex = currentFilter.filters.findIndex(f => f.field === filterField);
            if(filterIndex >= 0) currentFilter.filters.splice(filterIndex, 1);
            gds.filter(currentFilter);
        }
        highlightColMenus();
    });
}

const initGrid = () => {
    $pcoGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, 
        columns: [{
                field: 'Contract', 
                title: 'Contract', 
                attributes: {class: ''}, 
                type: 'string', 
                template: function (dataItem) {
                    return `<div data-contract='${dataItem.Contract}'>${dataItem.Contract} - ${dataItem.ContractDescription}</div>`;
                }
            },{
                field: 'Dept', 
                title: 'Department', 
                attributes: {class: ''}, 
                type: 'string', 
                template: function (dataItem) {
                    return dataItem.Dept;
                }
            }, {
                field: 'ProjectManagerName', 
                title: 'PM', 
                attributes: {class: ''}, 
                type: 'string', 
                template: function (dataItem) {
                    return dataItem.ProjectManagerName;
                }
            }, {
                field: 'ContractAmount', 
                title: 'Current Contract Amount', 
                attributes: {class: ''}, 
                type: 'number', 
                format: '{0:c0}'
            }, {
                field: 'PcoATotal', 
                title: 'PCO-A Total', 
                attributes: {class: ''}, 
                type: 'number', 
                format: '{0:c0}'
            }, {
                field: 'PcoBTotal', 
                title: 'PCO-B Total', 
                attributes: {class: ''}, 
                type: 'number', 
                format: '{0:c0}'
            }, {
                field: 'PcoCTotal', 
                title: 'PCO-C Total', 
                attributes: {class: ''}, 
                type: 'number', 
                format: '{0:c0}'
            }
        ], 
        dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'aid', 
                    fields: {
                        Contract: {editable: false, type: 'string'},
                        ContractAmount: {editable: false, type: 'number'},
                        Dept: {editable: false},
                        ContractDescription: {editable: false},
                        ProjectManagerName: {editable: false, type: 'string'},
                        PcoATotal: {editable: false, type: 'number'},
                        PcoBTotal: {editable: false, type: 'number'},
                        PcoCTotal: {editable: false, type: 'number'},
                        PcoAFullyApproved: {editable: false, type: 'boolean'},
                        PcoBFullyApproved: {editable: false, type: 'boolean'},
                        PcoCFullyApproved: {editable: false, type: 'boolean'},
                        LegalReviewRequired: {editable: false, type: 'boolean'}
                    }
                }
            }, 
            transport: {
                read: {
                    url: '/Operations/PcoApproval/GetPcoApprovals', type: 'GET', dataType: 'json'
                }, parameterMap (data, type) {
                    const rs = {};
                    if (type === 'read') {
                        rs.company = $('#Company').val();
                        return rs;
                    }
                }
            }
        }, 
        dataBound (arg) {
            pcoGridDataBound(arg);
        }, 
        mobile: true, 
        scrollable: true, 
        sortable: {
            mode: 'multiple'
        }, 
        filterable: {
            mode: 'menu',
            extra: false,
            operators: {
                string: { 
                    contains: 'Contain',
                    doesnotcontain: 'Do not contain'
                },
                number: {
                    eq: 'Equal to',
                    lt: 'Less than',
                    gt: 'Greater than',
                    lte: 'Less than or equal to',
                    gte: 'Greater than or equal to'
                }
            }
        },
        columnMenuInit (e) {
            const filterForm = e.container.find('form.k-filter-menu')
            if(/Pco[ABC]Total/.test(e.field)) {
                addPcoApprovalFilter(filterForm, e.field);
            }
        },
        editable: true, 
        columnMenu: true
    });
}